"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isClausewitzObjectOfIdentifier = exports.createClausewitzObject = void 0;
function createClausewitzObject(identifier, value) {
    if (typeof identifier === 'number') {
        return { identifier: 'Other', value: identifier };
    }
    if (value !== undefined) {
        return { identifier: identifier, value: value };
    }
    else {
        return { identifier: identifier };
    }
}
exports.createClausewitzObject = createClausewitzObject;
/**
 * IClausewitzObject<T> type assertion
 */
function isClausewitzObjectOfIdentifier(x, y) {
    return x.identifier === y;
}
exports.isClausewitzObjectOfIdentifier = isClausewitzObjectOfIdentifier;
